<template>
  <div class="login-page">
    <button
      class="secret-test-sentry-button-in-the-top-right"
      @click="throwErrorTestSentry"
    />
    <div class="container">
      <!-- email form -->
      <form
        v-show="!pw_login && !pw_reset_sent"
        class="login card mx-auto needs-validation"
        action="/tickets"
        novalidate
        data-vv-scope="login-form"
      >
        <div class="card-body">
          <div class="text-center mb-3">
            <a
              class="logo"
              href="#"
              @click.prevent.stop="$router.push('/entries')"
            >
              <main-logo
                width="126"
                height="40"
                style="margin-bottom: 32px;"
              />
            </a>
          </div>

          <div
            v-if="token || viewas"
            style="text-align: center;"
          >
            Please wait while we log you in.
          </div>
          <div v-else>
            <validation-observer ref="form">
              <div class="form-group">
                <validation-provider
                  ref="username"
                  v-slot="{ touched, pristine, valid, invalid, validated }"
                  name="email"
                  rules="required|email"
                >
                  <div class="form-control__wrapper">
                    <input
                      id="login"
                      v-model="username"
                      autocapitalize="off"
                      spellcheck="false"
                      :style="{ border:redLine}"
                      class="form-control"
                      :class="{'is-invalid': error_validation}"
                      type="text"
                      name="username"
                      placeholder="Email"
                      required="required"
                    >
                  </div>
                  <span
                    class="caption-regular text-error"
                  >
                    {{ error_validateEmail ? 'Confirm username or contact your administrator for access.' : errorMessage }}
                  </span>
                </validation-provider>
              </div>
            </validation-observer>
            <div class="text-center">
              <base-button
                id="login-btn"
                inverse
                :style="error_validation ? 'margin-top:22px;' : 'margin-top:26px;'"
                style="height: 44px; font-size: 14px; width: 372px; margin: 0px"
                @click="sendForm()"
              >
                Continue
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <!-- password form -->
      <form
        v-show="pw_login && !pw_reset"
        class="login card mx-auto needs-validation"
        novalidate
        action="/tickets"
        data-vv-scope="login-form"
      >
        <div class="card-body">
          <div class="text-center title-logo">
            <base-icon
              icon="arrow-left"
              class="mr-2"
              @click="toggleback"
            />
            <a
              class="logo"
              href="#"
              @click.prevent.stop="$router.push('/entries')"
            >
              <main-logo
                class=""
                width="126"
                height="40"
                style="margin-bottom: 2rem;"
              />
            </a>
            <div
              class="mr-2"
              style="width: 36px; height: 88px;"
            />
          </div>

          <div>
            <validation-observer ref="form">
              <div class="form-group">
                <validation-provider
                  ref="username"
                  v-slot="{ errors, touched, pristine, valid, invalid, validated }"
                  name="password"
                  rules="required"
                >
                  <div class="position-relative form-control__wrapper">
                    <input
                      id="login"
                      v-model="password"
                      autocapitalize="off"
                      :style="{ border:redLine}"
                      class="form-control"
                      :class="{'is-invalid': errorMessage}"
                      :type="`${showPassword ? 'text' : 'password'}`"
                      name="password"
                      placeholder="Password"
                    >
                    <!-- in design on issue SR-1541 show password is deleted -->
                    <!-- in design on issue SR-1954 show password is show -->
                    <base-icon
                      :icon="`pass-${showPassword ? 'off' : 'on'}`"
                      class="position-absolute action"
                      :style="`${ errorMessage ? 'display: none' : ''}`"
                      @click="showPassword = !showPassword"
                    />
                  </div>
                  <span
                    class="caption-regular text-error"
                  >
                    {{ errorMessage }}
                  </span>
                </validation-provider>
              </div>
            </validation-observer>
            <div class="text-center">
              <base-button
                id="login-btn"
                class="forgotMyPassword"
                :style="errorMessage ? 'margin-top:29px;' : 'margin-top:26px !important;'"
                style="width: 372px; height: 44px; margin: 0px;"
                inverse
                @click="handleSubmit()"
              >
                Login
              </base-button>
              <base-button
                class="forgotMyPassword"
                text
                block
                color="$gray"
                @click="toggleForm()"
              >
                Forgot password
              </base-button>
            </div>
          </div>
        </div>
      </form>
      <!-- forgot -->
      <form
        v-show="pw_reset"
        class="login card mx-auto needs-validation"
        novalidate
        data-vv-scope="pw-reset-form"
      >
        <div class="card-body">
          <div
            class="text-center mb-3"
            style="display: flex; margin-top: 7px; justify-content: space-evenly; height: 33px;"
          >
            <base-icon
              style="position: relative;right: 5px;"
              icon="arrow-left"
              @click="toggleForm"
            />
            <p class="forgotPass">
              Reset your password
            </p>
          </div>

          <base-alert />
          <div>
            <validation-observer ref="resetform">
              <validation-provider
                ref="username"
                v-slot="{ errors, touched, pristine, valid, invalid, validated }"
                name="email"
                rules="required|email"
              >
                <div class="position-relative form-control__wrapper">
                  <input
                    id="login"
                    v-model="email"
                    class="form-control"
                    autocapitalize="off"
                    spellcheck="false"
                    :class="{'is-invalid': (invalid && touched) || (pristine && validated && invalid)}"
                    type="text"
                    name="username"
                    placeholder="Email"
                    style="margin-top: 32px;margin-bottom: 32px; width: 372px; height: 44px;"
                  >
                  <template>
                    <div
                      v-for="(error, index) in errors"
                      :key="`account_error_${index}`"
                    >
                      <div
                        v-if="touched || (pristine && validated && invalid)"
                        class="invalid-feedback"
                      >
                        {{ error }}
                      </div>
                    </div>
                  </template>
                </div>
                <div class="text-center">
                  <div>
                    <base-button
                      v-if="!pw_reset_sent && !pw_spinner"
                      id="send-reset"
                      inverse
                      variant="primary"
                      style="width: 372px; height: 44px; margin: 0"
                      @click.prevent.stop.native="handlePasswordReset"
                    >
                      Send reset instructions
                    </base-button>
                  </div>
                  <b-spinner
                    v-if="pw_spinner"
                    variant="primary"
                  />
                  <div>
                    <base-button
                      style="color:#333; margin-top:31px; font-size:14px; padding: 0;;"
                      text
                      block
                      color="$gray"
                      href="#"
                      @click="toggleForm"
                    >
                      Return to login
                    </base-button>
                  </div>
                </div>
              </validation-provider>
            </validation-observer>
          </div>
        </div>
      </form>
      <div
        v-show="pw_reset_sent && !pw_login"
        class="login card mx-auto"
        style="border-radius: 4px; box-shadow: unset;"
      >
        <div class="card-body">
          <div class="text-center mb-3" style="margin-top: 20px">
            <p class="forgotPassDone" style="margin-right: unset;">
              Done!
            </p>
          </div>
          <p class="paragraft_messages">
            We've sent an email to
            <span class="messages_email">{{ email }}</span>
            with reset instructions.
          </p>
          <div style="margin-top: 2rem;">
            <base-button
              inverse
              block
              style="height: 44px; font-size: 14px; background-color: #333333; margin-bottom: 2px;"
              variant="primary"
              href="#"
              @click="toggleForm"
            >
              Return to login
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';
import { userService } from '@/_services';
import { sendToMixPanel } from '@/_utilities/seerMixPanel';
import { MIXPANEL_EVENTS } from '../../_utilities/Enums';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      username: '',
      password: '',
      submitted: false,

      email: '',
      pw_login: false,
      pw_reset: false,
      pw_reset_sent: false,
      pw_spinner: false,
      token: false,

      showPassword: false,
      message_validation: '',
      redLine: '',
      error_validation: false,
      error_validateEmail: false,
      errorMessage: '',
    };
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    validateEmail() {
      // eslint-disable-next-line no-useless-escape
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.username)) {
        return true;
      } else {
        return false;
      }
    },
    validatePassword() {
      // eslint-disable-next-line no-useless-escape
      if (this.password) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    username() {
      // If alert is present and user enters updates text, clear alert
      this.clear();
    },
    password() {
      this.clear();
    },
  },
  created() {
    const { token, viewas } = this.$route.query;
    this.token = token;
    this.viewas = viewas;
    // Store a copy of user
    const superuser = viewas ? this.$store.state.account.user : {};

    this.logout();

    // Login via Signin as
    if (viewas) {
      this.saveSuperuser(superuser);
      sendToMixPanel(MIXPANEL_EVENTS.signInAttempt, {
        account_id: this.username,
        sign_in_type: 'token login',
      });
      this.tokenlogin({ token: viewas }).then((res) => {
        sendToMixPanel(MIXPANEL_EVENTS.signedIn, {
          account_id: this.username,
          sign_in_type: 'token login',
        });
      }).catch((err) => {
        sendToMixPanel(MIXPANEL_EVENTS.signInFailure, {
          account_id: this.username,
          sign_in_type: 'token login',
        });
      });
    }
    // Login via token
    if (token) {
      sendToMixPanel(MIXPANEL_EVENTS.signInAttempt, {
        account_id: this.username,
        sign_in_type: 'token login',
      });
      this.tokenlogin({ token }).then((res) => {
        sendToMixPanel(MIXPANEL_EVENTS.signedIn, {
          account_id: this.username,
          sign_in_type: 'token login',
        });
      }).catch((err) => {
        sendToMixPanel(MIXPANEL_EVENTS.signInFailure, {
          account_id: this.username,
          sign_in_type: 'token login',
        });
      });
    }
  },
  methods: {
    ...mapActions('account', ['login', 'logout', 'tokenlogin', 'saveSuperuser']),
    ...mapActions('alert', ['success', 'clear']),
    debug() {
      this.clear();
    },
    isEmailBurberry() {
      let { username } = this;
      username = username.toLowerCase();
      const splitEmail = username.split('@');
      const domainEmail = splitEmail[1];
      if (domainEmail && domainEmail.toLowerCase() === 'burberry.com') {
        return true;
      }
      return false;
    },
    sendForm() {
      if (this.validateEmail) {
        this.errorMessage = '';
        this.redLine = '';
        this.error_validation = false;
        this.error_validateEmail = false;
        if (this.isEmailBurberry()) {
          userService.getBurberryLoginLink().then((r) => {
            const { burberry_login_link } = r.data;
            window.location.href = burberry_login_link;
          });
        } else {
          this.pw_login = !this.pw_login;
        }
        this.clear(); // Clear error message from base-alert
        this.pw_reset_sent = false;
        this.pw_spinner = false;
      } else if (this.username.length === 0) {
        this.redLine = '1px solid red';
        this.errorMessage = 'Required field.';
        this.error_validation = true;
      } else {
        this.redLine = '1px solid red';
        this.error_validation = true;
        this.error_validateEmail = true;
      }
    },
    handleSubmit() {
      this.submitted = true;
      const { username, password } = this;

      sendToMixPanel(MIXPANEL_EVENTS.signInAttempt, {
        account_id: username,
        sign_in_type: 'customer login',
      });
      if (this.validatePassword) {
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.login({
              username,
              password,
            }).then((res) => {
              sendToMixPanel(MIXPANEL_EVENTS.signedIn, {
                account_id: username,
                sign_in_type: 'customer login',
              });
            }).catch((err) => {
              this.redLine = '1px solid red';
              this.error_validation = true;
              this.errorMessage = 'Password not valid. Try again or click forgot password to reset.';
              sendToMixPanel(MIXPANEL_EVENTS.signInFailure, {
                account_id: username,
                sign_in_type: 'customer login',
              });
            });
          }
        });
      } else {
        this.redLine = '1px solid red';
        this.error_validation = true;
        this.errorMessage = 'Enter a password.';
      }
    },
    handlePasswordReset() {
      this.$refs.resetform.validate().then((result) => {
        if (result) {
          this.pw_spinner = true;
          userService.passwordReset(this.email)
            .then((response) => {
              this.pw_reset_sent = true;
              this.pw_reset = false;
              this.pw_login = false;
              this.success('Email sent');
            }).catch((response) => {
            // Show first error
              this.error(response.response?.data?.detail ? response.response?.data?.detail : 'Could not send email');
            }).finally(() => {
              this.pw_spinner = false;
            });
        }
      });
    },
    toggleForm() {
      this.pw_reset = !this.pw_reset;
      if (this.pw_reset_sent) {
        this.pw_reset = false;
      }
      this.clear(); // Clear error message from base-alert
      this.pw_reset_sent = false;
      this.pw_spinner = false;
      this.errorMessage = '';
      this.redLine = '';
      this.error_validation = false;
      this.error_validateEmail = false;
    },
    throwErrorTestSentry() {
      // https://stackoverflow.com/questions/47333846/how-do-i-test-that-sentry-is-reporting-errors
      /* eslint-disable no-undef */
      christinaGreatAtCoding();
    },
    toggleback() {
      this.pw_login = !this.pw_login;
      this.clear(); // Clear error message from base-alert
      this.pw_reset_sent = false;
      this.pw_spinner = false;
      this.errorMessage = '';
      this.redLine = '';
      this.error_validation = false;
      this.error_validateEmail = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.form-control__wrapper {
  width: 100% !important;
  // margin: 8px 10% -8px 10%;
  .action {
    // padding: 4px; // will be substracted. Clickable area padding.
    margin-right: 14.08px;
    margin-top: 16.33px;
    margin-bottom: 16.33px;
    right: 0;
    top: 0;
    cursor: pointer;
  }
  input {
    border: 1px solid rgba(black, 0.25);
    &[type=password]:not(:placeholder-shown) {
      font-size: 10px !important;
      letter-spacing: 9px;
      padding-right: 30px;
    }
  }
}
::v-deep  .base-button--inverse {
  font-size: 12px;
  min-width: 123px;
  padding-top: 7px;
  padding-bottom: 8px;
  justify-content: center;
}
</style>
<style lang="scss">
body {
    background-color: #F2F1EE !important;
  }
  .paragraft_messages{
    font-family: 'SilkaLight';
    margin-top: 2rem;
    font-size: 16px;
  }
  .messages_email{
    font-size: 16px;
    color: #1B1B1B;
    font-family: 'SilkaMedium';
    // font-family: $font-family-sans-serif-bold;
  }
  .login-btn {
    font-family: $font-family-sans-serif-bold;
    letter-spacing: 1.5px;
    font-size: 15px;
  }

  #login-btn{
    width: 80%;
  }
  #send-reset{
    width: 80%;
    font-size:14px;
  }
  .login {
    margin-top: 8%;
    width: 500px;
    max-width: 500px;

    .card-body {
      padding-top: 40px;
      padding-left: 64px;
      padding-right: 64px;
      padding-bottom: 40px;
    }
  }

  // .logo > div {
  //   margin-bottom: 32px;
  // }

  form.login.card {
    border-radius: 6px;
    box-shadow: none !important;
  }
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    // border: 2px solid #F5EFEB ;
    -webkit-box-shadow: none !important;
    transition: background-color 5000s ease-in-out 0s;
    font-size: 13.5px;
    font-family: $font-family-sans-serif;
  }

  .form-group {
    margin-bottom: 0 !important;
    font-size: 13.5px !important;

    input#login.form-control {
      height: 44px;
      width: 372px;
      margin-bottom: 6px;
      align-self: center;
      font-size: 14px;
      border-radius: 6px;
      background-color: #fff !important;
      -moz-appearance: none !important;
      -webkit-appearance: none !important;

      &:active, &:visited, &:focus, &:focus-within {
        font-family: $font-family-sans-serif;
        font-size: 13.5px;
        background-color: #fff !important;
        -moz-appearance: none !important;
        -webkit-appearance: none !important;
      }

    }
    .form-control::placeholder{
      color: #909090;
      opacity: 1;
    }

    :-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: #909090;
    }

    ::-ms-input-placeholder { /* Microsoft Edge */
      color: #909090;
    }
  }

  .invalid-feedback {
    top: -30px;
    position: relative;
    margin: 0px 10% 0px 0%;
  }

  .secret-test-sentry-button-in-the-top-right {
    // position: fixed;
    // top:0px;
    // right:0px;
    // cursor: pointer;
    // width:10px;
    // height:10px;

    // background-color:red;
    background: transparent;
    border: none !important;
  }
  .forgotMyPassword{
    font-family: 'Silka';
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    font-size: 14px !important;
    color: #333333;
    // text-decoration: underline;
    margin-top: 17.5px !important;
  }
  .forgotPass{
    margin-right: 25px;
    margin-top: 5px;
    font-family: 'Tiempos';
    display: inline;
    font-style: normal;
    font-weight: 600;
    font-size: 29px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #333;
    word-break: break-all;
  }
  .forgotPassDone{
    margin-right: 80px;
    margin-top: 15px;
    font-family: 'Tiempos';
    display: inline;
    font-style: normal;
    font-weight: 600;
    font-size: 27px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: #333;
    word-break: break-all;
  }
  .forgotPassDetail {
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
  }
  .is-invalid{
    border-color: $validation-error-color;
  }
  .title-logo{
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    max-height: 40px;
  }
</style>
